export default "__VITE_ASSET__5hBdNEkB__"